import React, {useMemo} from 'react';

import {Card, Block, Dialog, DialogBody, DialogFooter, Button, VF, Space, ModalComponentProps, makeValidate, Yup} from '@mc/ui-v4';

import {Form, FormRenderProps} from 'react-final-form';
import {CiselnikVO} from '../../../api';
import {buildCiselnikParentSelectTree} from '../../../helpers/Formatter';

type Props = ModalComponentProps & {
    initialValues?: CiselnikVO;
    isEdit: boolean;
    onSubmit: (data: CiselnikVO) => void;
    /** Hodnoty číselníku, které lze zvolit jako nadřazenou hodnotu (bez sebe a svých potomků). */
    parentOptions?: CiselnikVO[];
};

export const CiselnikValueModal: React.FC<Props> = ({onClose, isEdit, initialValues, onSubmit, parentOptions}) => {
    const validate = useMemo(
        () =>
            makeValidate(
                Yup.object().shape({
                    nazev: Yup.string().required('Zadejte název'),
                }),
            ),
        [],
    );

    // Nadřazenou hodnotu vybíráme ve stromu (stejně jako se číselník zobrazuje v dialogu featury).
    const parentItems = useMemo(() => buildCiselnikParentSelectTree(parentOptions), [parentOptions]);

    return (
        <Form<CiselnikVO>
            initialValues={initialValues}
            onSubmit={onSubmit}
            validate={async data => {
                return await validate(data);
            }}
        >
            {({submitting, handleSubmit}: FormRenderProps<CiselnikVO>) => {
                return (
                    <Dialog size="md" onClose={onClose} title={isEdit ? 'Úprava hodnoty' : 'Nová hodnota'}>
                        <DialogBody>
                            <Space vertical>
                                <Card mode={'edit'}>
                                    <Block>
                                        <VF.String label={'Hodnota'} name={'nazev'} required />
                                        {parentItems.length > 0 && (
                                            <VF.SelectBox
                                                label={'Nadřazená hodnota'}
                                                name={'parentTempId'}
                                                items={parentItems}
                                                tree
                                                alwaysExpanded
                                                useIdAsValue
                                                allowNullValue
                                                placeholder={'Kořenová hodnota'}
                                            />
                                        )}
                                    </Block>
                                </Card>
                            </Space>
                        </DialogBody>
                        <DialogFooter>
                            <Button style="default" onClick={onClose} disabled={submitting}>
                                Zrušit
                            </Button>
                            <Button style="primary" onClick={handleSubmit} disabled={submitting}>
                                {isEdit ? 'Uložit' : 'Vytvořit'}
                            </Button>
                        </DialogFooter>
                    </Dialog>
                );
            }}
        </Form>
    );
};
